export default __webpack_public_path__ + "static/media/DisneyPlus_EmotionalBannerMob.3f985234.png";